module.exports = "https://web-assets.ifttt.com/packs/media/shared/applet-card-private-icon-10477efb.svg";